export default __webpack_public_path__ + "static/home-three-newsletter-bg-7d1178666461f924c258b850af497acd.jpg";